import type { Messages } from "../types";

export const id = {
  "common": {
    "brand": "UN8",
    "brandTag": "Kencan Kristen eksklusif",
    "continue": "Lanjutkan",
    "leave": "Keluar",
    "leaveForNow": "Keluar untuk sekarang",
    "yes": "Ya",
    "no": "Tidak",
    "goBack": "Kembali",
    "saving": "Menyimpan…",
    "submitting": "Mengirim…",
    "pleaseWait": "Mohon tunggu…",
    "ellipsis": "…",
    "male": "Pria",
    "female": "Wanita",
    "phases": {
      "gate": "Gerbang",
      "verify": "Verifikasi",
      "setup": "Pengaturan",
      "profile": "Profil"
    },
    "storageQuota": "Ponsel ini kehabisan ruang untuk jawaban tersimpan. Bebaskan sebagian penyimpanan, lalu coba lagi.",
    "storageDisabled": "Peramban ini tidak akan menyimpan jawaban Anda. Matikan mode pribadi, atau izinkan data situs, lalu muat ulang.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min {min} karakter"
  },
  "welcome": {
    "promise": "Tujuan kami adalah Anda menghapus aplikasi ini secepat mungkin.",
    "sub": "UN8 membantu orang Kristen lajang yang serius menemukan pasangan hidup — lalu pergi. Terverifikasi. Nilai dulu. Tanpa swipe tanpa akhir.",
    "signedInAs": "Masuk sebagai {email}",
    "liveServer": " · server langsung",
    "deviceOnly": " · hanya perangkat ini",
    "migrateOffer": "Perangkat ini masih punya profil lokal. Unggah ke server bersama agar ponsel lain bisa melihat Anda setelah moderasi? Tidak ada yang diunggah sampai Anda memilih.",
    "uploadLocalProfile": "Unggah profil lokal saya",
    "keepOnDevice": "Simpan hanya di perangkat ini",
    "migrateNeedGender": "Pilih Pria atau Wanita di profil Anda terlebih dahulu.",
    "migrateDone": "Teks profil diunggah. Unggah ulang ID, video, dan foto agar moderasi dapat meninjaunya.",
    "deleteConfirm": "Hapus secara permanen akun, semua pesan, dan semua media Anda (termasuk ID dan video) dari server?",
    "accountDeleted": "Akun dihapus.",
    "begin": "Mulai",
    "continueOnboarding": "Lanjutkan onboarding",
    "logIn": "Masuk",
    "logOut": "Keluar",
    "reviewConsole": "Konsol tinjauan",
    "matching": "Pencocokan",
    "deleteMyAccount": "Hapus akun saya"
  },
  "faith": {
    "eyebrow": "Gerbang iman",
    "title": "Hanya orang Kristen",
    "text": "UN8 adalah komunitas pengikut Yesus Kristus, bagi anggota yang mencari pasangan berorientasi pernikahan yang berbagi iman itu. Gerbang ini tidak dapat dilewati.",
    "yesTitle": "Saya orang Kristen",
    "yesBody": "Saya mengikuti Yesus Kristus dan mencari pasangan berorientasi pernikahan yang berbagi iman ini.",
    "noTitle": "Saya bukan orang Kristen",
    "noBody": "UN8 bukan tempat yang tepat bagi saya — dan itu tidak apa-apa.",
    "respectTitle": "Dengan hormat",
    "respectBody": "UN8 dibangun untuk satu komunitas, dan kami lebih suka jujur daripada membuang waktu Anda. Gunakan Keluar di bawah, atau Kembali, jika ini bukan rumah Anda.",
    "sharedTitle": "Fondasi bersama",
    "sharedBody": "Iman di sini bukan label. Ia adalah tanah tempat Anda bertemu.",
    "hintNotChristian": "UN8 untuk pengikut Yesus Kristus. Ketuk Keluar di bawah, atau pilih opsi Kristen jika itu Anda.",
    "hintUnset": "Ketuk “Saya orang Kristen” untuk melanjutkan, atau Keluar / Kembali jika ini bukan rumah Anda."
  },
  "rules": {
    "eyebrow": "Perjanjian komunitas",
    "title": "Bagaimana kita saling memperlakukan",
    "text": "Tegaskan setiap aturan. Ketiganya wajib. Pelanggaran berujung pada penghapusan permanen. Profil palsu dilarang selamanya.",
    "agreeContinue": "Saya setuju — lanjutkan",
    "respectful": {
      "title": "Hormatilah",
      "description": "Berbicara dan bertindak dengan martabat. Setiap orang di sini dibuat menurut gambar Allah."
    },
    "noSexualContent": {
      "title": "Tanpa konten seksual",
      "description": "Tanpa foto, pesan, atau permintaan eksplisit. Kemurnian di sini tidak opsional."
    },
    "noDominance": {
      "title": "Jangan mendominasi atau mengendalikan",
      "description": "Tanpa paksaan, manipulasi, atau tekanan. Kasih tidak mengendalikan."
    },
    "hint": "Centang ketiga janji sebelum Anda melanjutkan."
  },
  "intent": {
    "eyebrow": "",
    "title": "Kamu mencari apa?",
    "text": "",
    "marriage": {
      "label": "Pasangan hidup",
      "description": ""
    },
    "discernment": {
      "label": "Pembedaan yang serius",
      "description": ""
    },
    "notCasual": {
      "label": "Bukan yang santai",
      "description": ""
    },
    "hint": "Pilih satu."
  },
  "account": {
    "eyebrow": "Akun",
    "title": "Buat akses Anda",
    "text": "Handle Anda membuat id pengguna yang stabil. Aplikasi, verifikasi, suka, dan pasangan semuanya terikat pada id itu. Tidak ada email yang dikirim.",
    "recoveryTitle": "Simpan kode pemulihan Anda",
    "recoveryText": "Ditampilkan sekali. Tanpanya, frasa sandi yang hilang tidak dapat diatur ulang dalam uji tertutup ini.",
    "savedContinue": "Saya sudah menyimpannya — lanjutkan",
    "handle": "Handle",
    "handlePlaceholder": "anda@contoh.com atau handle singkat",
    "passphrase": "Frasa sandi",
    "passphrasePlaceholder": "Minimal 8 karakter",
    "signedInTitle": "Sudah masuk",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Standar kepercayaan",
    "trustBody": "Tidak ada profil yang terlihat sampai verifikasi identitas selesai dan moderasi menyetujui Anda.",
    "continueToVerification": "Lanjut ke verifikasi",
    "hintEmail": "Ketik alamat email yang menyertakan @.",
    "hintPassword": "Pilih kata sandi minimal 8 karakter."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verifikasi",
      "title": "Kepercayaan adalah gerbang",
      "text": "Unggah ID pemerintah, video konfirmasi, dan {min}–{max} foto nyata. Semuanya masuk antrean tinjauan sebelum profil Anda dapat muncul.",
      "whyTitle": "Mengapa kami memverifikasi",
      "whyBody": "Catfishing dan setengah kebenaran tidak punya tempat di sini. Profil palsu dilarang secara permanen. Media disimpan dengan status pending_review sampai disetujui.",
      "start": "Mulai verifikasi"
    },
    "steps": {
      "id": {
        "title": "ID pemerintah",
        "description": "Paspor atau KTP nasional — kamera atau unggah berkas."
      },
      "video": {
        "title": "Video konfirmasi",
        "description": "Rekaman singkat yang membuktikan Anda hadir."
      },
      "photos": {
        "title": "Foto nyata",
        "description": "Tujuh hingga sepuluh foto jelas tentang diri Anda."
      },
      "review": {
        "title": "Tinjauan integritas",
        "description": "Unggahan tetap pending_review sampai staf mengonfirmasi."
      }
    },
    "id": {
      "eyebrow": "Langkah 1 dari 4",
      "title": "ID pemerintah",
      "text": "Ambil atau unggah paspor atau KTP nasional Anda. Tidak ada yang diposting publik — status tetap pending_review sampai staf mengonfirmasi.",
      "savedTitle": "ID tersimpan",
      "savedBody": "Berikutnya adalah video konfirmasi singkat wajah Anda, lalu 7 hingga 10 foto nyata diri Anda. Lanjutkan terbuka saat ID ini menunjukkan tersimpan.",
      "hint": "Ambil atau unggah foto ID pemerintah Anda, lalu tunggu sampai tertulis tersimpan."
    },
    "video": {
      "eyebrow": "Langkah 2 dari 4",
      "title": "Video konfirmasi",
      "text": "Rekam klip singkat atau unggah satu. Hadap kamera. Bicara jelas. Ini membuktikan Anda hadir — bukan galeri yang di-scrape.",
      "hint": "Rekam video konfirmasi singkat, lalu tunggu sampai tertulis tersimpan."
    },
    "photos": {
      "eyebrow": "Langkah 3 dari 4",
      "title": "Foto nyata",
      "text": "Tambahkan {min}–10 foto terbaru diri Anda. Gunakan kamera atau pustaka. Ketuk × untuk menghapus foto apa pun.",
      "continueToReview": "Lanjut ke tinjauan",
      "hint": "Tambahkan {min} hingga 10 foto jelas diri Anda. Lanjutkan terbuka saat mereka tersimpan."
    },
    "review": {
      "eyebrow": "Langkah 4 dari 4",
      "title": "Tinjauan integritas",
      "text": "Media diantrekan sebagai pending_review{underUser}. Pasangan dan suka akan memakai id yang sama.",
      "underUser": " di bawah pengguna {userId}",
      "governmentId": "ID pemerintah",
      "confirmationVideo": "Video konfirmasi",
      "photos": "Foto",
      "missing": "Hilang",
      "filesReady": "{count} berkas siap",
      "submittedTitle": "Dikirim untuk tinjauan",
      "submittedText": "Id aplikasi sama dengan auth user id agar approve → pool dan suka saling tetap selaras.",
      "submitContinue": "Kirim & lanjutkan"
    }
  },
  "setup": {
    "eyebrow": "Pengaturan akun",
    "title": "Katakan yang benar tentang diri Anda",
    "text": "Jawaban ini membentuk pencocokan dan muncul dalam tinjauan. Kebohongan lembut membuang waktu semua orang — termasuk Anda.",
    "beginSetup": "Mulai pengaturan",
    "pillars": {
      "faith": {
        "name": "Iman",
        "text": "Mengapa Anda mengikuti Kristus."
      },
      "character": {
        "name": "Karakter",
        "text": "Kesetiaan, kejujuran, semangat, komitmen — dinilai 1–10."
      },
      "story": {
        "name": "Cerita",
        "text": "Siapa Anda dan apa yang Anda cari."
      },
      "life": {
        "name": "Hidup",
        "text": "Hobi, membaca, dan pekerjaan."
      }
    },
    "whyChristian": {
      "eyebrow": "Iman",
      "title": "Mengapa Anda orang Kristen?",
      "text": "Jawaban singkat dan jujur. Bukan khotbah — alasan yang milik Anda.",
      "label": "Jawaban Anda",
      "placeholder": "mis. Saya bertemu Kristus dalam musim kehilangan dan mengikuti-Nya sejak itu…",
      "hint": "Tulis setidaknya {min} karakter tentang mengapa Anda mengikuti Yesus."
    }
  },
  "scales": {
    "eyebrow": "Skala karakter",
    "title": "Nilai diri Anda dengan jujur",
    "text": "Kesetiaan, kejujuran, semangat, komitmen — masing-masing dari 1 hingga 10. Membesar-besarkan angka hanya membuat Anda salah cocok nanti. Anda harus mengatur setiap skala untuk melanjutkan.",
    "loyalty": {
      "label": "Tingkat kesetiaan",
      "hint": "Jujurlah — seberapa setia Anda berdiri di samping mereka yang Anda kasihi?"
    },
    "honesty": {
      "label": "Tingkat kejujuran",
      "hint": "Seberapa konsisten Anda menyampaikan kebenaran sepenuhnya?"
    },
    "passion": {
      "label": "Seberapa bersemangatkah Anda?",
      "hint": "Keyakinan dan kedalaman — bukan pertunjukan."
    },
    "commitment": {
      "label": "Tingkat komitmen",
      "hint": "Seberapa siap Anda membangun sesuatu yang bertahan?"
    },
    "hint": "Geser setiap penggeser agar angka muncul — tidak boleh ada yang tetap sebagai tanda hubung."
  },
  "about": {
    "eyebrow": "Tentang Anda",
    "title": "Deskripsikan diri Anda dalam beberapa kalimat",
    "text": "Siapa Anda saat tidak ada yang berpura-pura. Temperamen, ritme, apa yang penting sehari-hari.",
    "label": "Tentang Anda",
    "placeholder": "Pagi yang tenang, serius soal keluarga, mudah tertawa, lebih suka kedalaman daripada kebisingan…",
    "hint": "Tulis setidaknya {min} karakter tentang diri Anda."
  },
  "looking": {
    "eyebrow": "Pasangan",
    "title": "Apa yang Anda cari?",
    "text": "Sifat karakter utama yang Anda inginkan pada calon pasangan — bukan daftar belanja penampilan.",
    "label": "Sifat karakter yang diinginkan",
    "placeholder": "mis. Iman yang teguh, kematangan emosional, kebaikan di bawah tekanan…",
    "hint": "Tulis setidaknya {min} karakter tentang pasangan yang Anda harapkan."
  },
  "loveReady": {
    "eyebrow": "Ambang",
    "title": "Siapkah Anda bertemu kasih hidup Anda?",
    "text": "UN8 ada agar lajang yang serius menemukan pasangan — lalu menghapus aplikasi. Hanya “Ya” yang membuka lanjutkan.",
    "yesTitle": "Ya — saya siap",
    "yesBody": "Saya di sini untuk bertemu pasangan saya dengan kejelasan dan keberanian.",
    "noTitle": "Belum",
    "noBody": "Jika Anda hanya menjelajah, komunitas ini bukan yang tepat.",
    "comeBackTitle": "Kembali saat siap",
    "comeBackBody": "UN8 untuk orang yang siap bertemu — bukan mengumpulkan opsi. Gunakan Keluar di bawah jika ingin berhenti untuk sekarang. Jawaban Anda tersimpan di ponsel ini.",
    "hintNo": "Hanya “Ya” yang melanjutkan. Jika belum siap, ketuk Keluar untuk sekarang — jawaban Anda tetap di ponsel ini.",
    "hintUnset": "Ketuk Ya jika Anda siap bertemu seseorang untuk pernikahan."
  },
  "lifestyle": {
    "eyebrow": "Gaya hidup",
    "title": "Bagaimana Anda hidup sehari-hari",
    "text": "Olahraga, hobi, membaca, dan profesi — sinyal praktis untuk kompatibilitas nyata.",
    "hobbies": "Olahraga atau hobi saat ini",
    "hobbiesPlaceholder": "Apa yang Anda lakukan secara aktif — bukan yang pernah Anda lakukan sekali.",
    "reading": "Apakah Anda membaca?",
    "readingHint": "1 = hampir tidak pernah · 10 = harian, membaca mendalam",
    "profession": "Profesi / sektor",
    "professionPlaceholder": "mis. Keperawatan · Perangkat lunak · Pendidikan · Keahlian",
    "hintHobbies": "Sebutkan setidaknya satu olahraga atau hobi yang benar-benar Anda lakukan.",
    "hintReading": "Geser “Apakah Anda membaca?” agar angka dari 1 hingga 10 muncul.",
    "hintProfession": "Ketik pekerjaan yang Anda lakukan, bahkan kata singkat."
  },
  "faithDepth": {
    "eyebrow": "Pencocokan · Iman",
    "title": "Seberapa sentral iman Anda?",
    "text": "Melayani Allah — seberapa penting dalam hidup Anda? Jawab dengan jujur. Pencocokan memakai ini untuk kedalaman, bukan pertunjukan.",
    "serving": "Melayani Allah — pentingnya",
    "servingHint": "10% … 100%. Geser dalam langkah 10.",
    "keepsCommandments": "Apakah Anda menaati perintah?",
    "grewUpInChurch": "Apakah Anda dibesarkan di gereja?",
    "churchAttendance": "Kehadiran di gereja",
    "frequent": {
      "label": "Sering",
      "hint": "Berkumpul secara teratur dengan tubuh Kristus."
    },
    "seldom": {
      "label": "Jarang",
      "hint": "Sesekali, bukan ritme mingguan."
    },
    "never": {
      "label": "Tidak pernah",
      "hint": "Saat ini tidak menghadiri."
    },
    "spreadsGospel": "Apakah Anda menyebarkan injil?",
    "hasIdols": "Apakah Anda punya berhala?",
    "hintServing": "Geser seberapa penting melayani Allah dalam hidup Anda.",
    "hintCommandments": "Jawab apakah Anda menaati perintah — Ya atau Tidak.",
    "hintGrewUp": "Jawab apakah Anda dibesarkan di gereja — Ya atau Tidak.",
    "hintAttendance": "Pilih seberapa sering Anda menghadiri gereja.",
    "hintGospel": "Jawab apakah Anda membagikan injil — Ya atau Tidak.",
    "hintIdols": "Jawab apakah Anda punya berhala — Ya atau Tidak."
  },
  "character": {
    "eyebrow": "Pencocokan · Karakter",
    "title": "Siapa Anda di rumah",
    "text": "Karakter untuk pacaran kudus — pembawa damai, sopan santun, kejujuran. Jawaban yang dibesar-besarkan hanya membuat Anda salah cocok nanti.",
    "peacemaker": "Apakah Anda pembawa damai?",
    "homebuilder": "Apakah Anda pembangun rumah?",
    "humorous": "Apakah Anda humoris?",
    "caring": "Peduli dan penuh kasih sayang?",
    "peacefulHome": "Apakah Anda ingin rumah yang damai — bebas pertengkaran?",
    "manners": "Sopan santun yang baik?",
    "honestyRating": "Peringkat kejujuran pada kuesioner ini",
    "honestyHint": "1–10 — seberapa jujur Anda menjawab?",
    "hintPeacemaker": "Jawab setiap Ya atau Tidak, mulai dari pembawa damai.",
    "hintHomebuilder": "Jawab apakah Anda pembangun rumah.",
    "hintHumorous": "Jawab apakah Anda humoris.",
    "hintCaring": "Jawab apakah Anda peduli dan penuh kasih sayang.",
    "hintPeaceful": "Jawab apakah Anda ingin rumah yang damai.",
    "hintManners": "Jawab apakah Anda memiliki sopan santun yang baik.",
    "hintHonesty": "Geser peringkat kejujuran Anda dari 1 hingga 10."
  },
  "history": {
    "eyebrow": "Pencocokan · Riwayat",
    "title": "Masa lalu dan kesiapan",
    "text": "Zat, masa kanak-kanak, bekas luka, dan apakah Anda siap untuk hubungan yang bertahan. Kebenaran di sini melindungi kalian berdua.",
    "marijuana": "Pernahkah Anda memakai marijuana?",
    "lsd": "Pernahkah Anda memakai LSD?",
    "otherDrugs": "Pernahkah Anda memakai obat lain?",
    "addicted": "Pernahkah Anda kecanduan?",
    "childhood": "Masa kanak-kanak yang stabil dan penuh kasih?",
    "scars": "Ada bekas luka / kerusakan?",
    "lasting": "Siap untuk hubungan yang bertahan?",
    "hintStart": "Jawab setiap Ya atau Tidak di halaman ini, mulai dari atas.",
    "hintLsd": "Jawab pertanyaan LSD — Ya atau Tidak.",
    "hintOtherDrugs": "Jawab apakah Anda pernah memakai obat lain.",
    "hintAddicted": "Jawab apakah Anda pernah kecanduan.",
    "hintChildhood": "Jawab apakah masa kanak-kanak Anda stabil dan penuh kasih.",
    "hintScars": "Jawab apakah Anda membawa bekas luka.",
    "hintLasting": "Jawab apakah Anda siap untuk hubungan yang bertahan."
  },
  "appearance": {
    "eyebrow": "Pencocokan · Penampilan",
    "title": "Tato",
    "text": "Tato Anda, dan apakah tato pada pasangan dapat diterima bagi Anda.",
    "hasTattoos": "Apakah Anda punya tato?",
    "acceptsPartner": "Menerima tato pada pasangan?",
    "hintHas": "Katakan apakah Anda punya tato — Ya atau Tidak.",
    "hintAccepts": "Katakan apakah tato pada pasangan dapat diterima bagi Anda."
  },
  "home": {
    "eyebrow": "Pencocokan · Rumah & tanah",
    "title": "Tanah, keterampilan, swasembada",
    "text": "Herbal, menanam makanan, hutan buah, persiapan, pertanian komunitas, pengawetan, bertahan hidup — dan keterampilan khusus apa pun.",
    "herbKnowledge": "Pengetahuan herbal?",
    "plantOwn": "Apakah Anda menanam buah dan sayur sendiri?",
    "fruitForest": "Tertarik pada hutan buah?",
    "prepping": "Bersiap menghadapi bencana?",
    "communityFarming": "Pertanian komunitas / hidup mandiri?",
    "canning": "Mengalengkan dan mengawetkan?",
    "survival": "Keterampilan bertahan hidup?",
    "specialSkills": "Keterampilan khusus (opsional)",
    "specialPlaceholder": "Apa pun lagi yang Anda bawa ke rumah tangga atau tanah…",
    "hintStart": "Jawab setiap Ya atau Tidak tentang tanah dan keterampilan, mulai dari atas.",
    "hintPlant": "Jawab apakah Anda menanam buah dan sayur sendiri.",
    "hintFruitForest": "Jawab apakah hutan buah menarik bagi Anda.",
    "hintPrepping": "Jawab apakah Anda bersiap menghadapi bencana.",
    "hintCommunity": "Jawab apakah pertanian komunitas menarik bagi Anda.",
    "hintCanning": "Jawab apakah Anda mengalengkan dan mengawetkan makanan.",
    "hintSurvival": "Jawab apakah Anda punya keterampilan bertahan hidup."
  },
  "family": {
    "eyebrow": "Pencocokan · Keluarga",
    "title": "Anak, kedalaman iman, zat",
    "text": "Apa yang Anda butuhkan pada pasangan mengenai intensitas iman, anak, dan penggunaan zat di masa lalu.",
    "children": "Anak",
    "wants": {
      "label": "Ingin anak",
      "hint": "Membangun keluarga adalah bagian dari visi."
    },
    "doesNotWant": {
      "label": "Tidak ingin anak",
      "hint": "Tidak yang jelas tentang anak."
    },
    "open": {
      "label": "Terbuka",
      "hint": "Membedakan — belum terkunci ke arah mana pun."
    },
    "hasLivingWith": {
      "label": "Punya anak — tinggal bersama mereka",
      "hint": "Anak sudah menjadi bagian dari kehidupan sehari-hari."
    },
    "requiredFaith": "Tingkat iman minimum yang Anda butuhkan pada pasangan",
    "requiredFaithHint": "10% … 100%. Gerbang keras ketika kedua belah pihak sudah menjawab.",
    "acceptsSubstances": "Menerima penggunaan zat di masa lalu pada pasangan?",
    "hintChildren": "Pilih satu kartu tentang anak.",
    "hintFaith": "Geser tingkat iman minimum yang Anda harapkan pada pasangan.",
    "hintSubstances": "Katakan apakah penggunaan zat di masa lalu pada pasangan dapat diterima."
  },
  "ancestry": {
    "eyebrow": "Pencocokan · Latar belakang",
    "title": "Preferensi latar belakang",
    "text": "Bagikan latar belakang Anda dan apa yang Anda terbuka pada pasangan. Ini hanya membentuk peringkat — tidak pernah menyembunyikan seseorang dari dek.",
    "yourBackground": "Latar belakang Anda (pilih semua yang berlaku)",
    "openToPartner": "Terbuka pada pasangan",
    "codeDesc": "Kode: {code}",
    "anyDesc": "Preferensi terkuat untuk keluasan — disarankan jika belum yakin.",
    "preferenceOnly": "Hanya preferensi — bukan gerbang.",
    "hintOwn": "Centang setidaknya satu latar belakang yang menggambarkan Anda. Ini hanya membantu peringkat — tidak pernah menyembunyikan siapa pun.",
    "hintAccepted": "Centang apa yang Anda terbuka pada pasangan, atau “Terbuka — tanpa preferensi”."
  },
  "interests": {
    "eyebrow": "Pencocokan · Minat",
    "title": "Apa yang Anda nikmati",
    "text": "Pilih setidaknya satu. Tumpang tindih membantu peringkat; keheningan tidak pernah dihukum.",
    "hint": "Centang setidaknya satu minat."
  },
  "reflection": {
    "eyebrow": "Pencocokan · Refleksi",
    "title": "Dengan kata-kata Anda sendiri",
    "text": "Keempat jawaban ini ditampilkan sepenuhnya dan tidak pernah dinilai. Tulis apa yang benar.",
    "describeYourself": "Deskripsikan diri Anda",
    "lifePurpose": "Tujuan hidup",
    "fifteenYear": "Anda dan kasih hidup Anda dalam 15 tahun",
    "weaknesses": "Kelemahan",
    "hintDescribe": "Deskripsikan diri Anda setidaknya {min} karakter.",
    "hintPurpose": "Tulis tujuan hidup Anda setidaknya {min} karakter.",
    "hintVision": "Tulis visi 15 tahun setidaknya {min} karakter.",
    "hintWeaknesses": "Sebutkan kelemahan setidaknya {min} karakter."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Beberapa hal penting",
    "text": "Tetap sederhana. Jenis kelamin di sini biner — pria atau wanita — untuk pencocokan yang jelas.",
    "firstName": "Nama depan",
    "firstNamePlaceholder": "Seperti yang ingin Anda dikenal",
    "age": "Usia",
    "agePlaceholder": "18+",
    "city": "Kota",
    "cityPlaceholder": "Di mana Anda berbasis",
    "sex": "Jenis kelamin",
    "maleBody": "Saya seorang pria.",
    "femaleBody": "Saya seorang wanita.",
    "hintName": "Ketik nama depan Anda (minimal dua huruf).",
    "hintAge": "Usia harus 18 atau lebih.",
    "hintCity": "Ketik kota tempat Anda tinggal.",
    "hintGender": "Pilih Pria atau Wanita agar pencocokan dapat bekerja."
  },
  "ready": {
    "title": "Anda boleh masuk.",
    "textNamed": "{name}, verifikasi dan pengaturan Anda tercatat. Media pending_review. Selamat datang di UN8 — temukan pasangan Anda, lalu hapus aplikasinya.",
    "text": "Verifikasi dan pengaturan Anda tercatat. Media pending_review. Selamat datang di UN8 — temukan pasangan Anda, lalu hapus aplikasinya.",
    "summaryAria": "Ringkasan pengaturan",
    "christianRules": "Kristen · aturan ditegaskan",
    "mediaLine": "ID · video · {photoCount} foto · antrean {pending}",
    "scalesLine": "Skala L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Jenis kelamin —",
    "professionFallback": "profesi",
    "userLine": "Pengguna {userId}",
    "enterMatching": "Masuk pencocokan",
    "needGender": "Kembali ke langkah profil dan pilih Pria atau Wanita, lalu coba lagi."
  },
  "match": {
    "brandTag": "Pencocokan",
    "navOnboarding": "Onboarding",
    "navReview": "Tinjauan",
    "navMatching": "Pencocokan",
    "logOut": "Keluar",
    "enterTitle": "Masuk pencocokan",
    "enterText": "Masuk dengan email yang sama dari onboarding. Aplikasi, pool, suka, dan pasangan semuanya memakai id pengguna stabil Anda.",
    "email": "Email",
    "emailPlaceholder": "anda@contoh.com",
    "password": "Kata sandi",
    "passwordPlaceholder": "Kata sandi Anda",
    "logIn": "Masuk",
    "guestOr": "Atau coba sesi tamu (id stabil per peramban · hanya demo)",
    "guestMan": "Tamu sebagai pria",
    "guestWoman": "Tamu sebagai wanita",
    "goOnboarding": "Ke onboarding →",
    "guestSession": "Sesi tamu · demo pool",
    "packTitle": "Empat pilihanmu",
    "packSkip": "Ketuk untuk lanjut",
    "newSelection": "Pilihan baru",
    "backToFour": "← Kembali ke empatmu",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "pria",
    "woman": "wanita",
    "navSelection": "Pilihan",
    "navMessages": "Pesan",
    "navProfile": "Profil",
    "tabToday": "Pilihan",
    "tabMatches": "Pasangan ({count})",
    "yourMatches": "Pasangan Anda",
    "matchesSub": "Minat saling yang persisten · {count} keluar {likesWord}",
    "like": "suka",
    "likes": "suka",
    "emptyMatches": "Belum ada minat timbal balik. Terus bedakan pilihan minggu ini.",
    "valuesScore": "Nilai {score}",
    "chatOpen": " · Chat terbuka",
    "tapToChat": " · Ketuk untuk chat",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Nilai {score}",
    "noProfileYet": "Belum ada profil",
    "noProfileText": "Selesaikan onboarding, atau ketuk Onboarding di atas, lalu Mulai. Pencocokan tamu ada di layar masuk jika Anda hanya ingin melihat.",
    "matchingPaused": "Pencocokan dijeda",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Belum ada yang ditampilkan",
    "todaysSetDone": "Itu pilihan minggu ini",
    "weeklyTitle": "4 pilihanmu minggu ini",
    "weeklyTitleCount": "{count} pilihanmu minggu ini",
    "weeklyCountdown": "Pilihan berikutnya dalam {days} hari",
    "weeklyCountdownOne": "Pilihan berikutnya dalam 1 hari",
    "weeklyCountdownSoon": "Pilihan berikutnya segera",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Itu pilihan minggu ini",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Belum ada siapa pun di daftar minggu ini. Pool sedang diisi — buka Pilihan lagi sebentar, atau kembali setelah lebih banyak anggota disetujui.",
    "emptyDone": "Kamu sudah menelusuri pilihan minggu ini. Kembali saat pembukaan berikutnya, atau atur ulang dek.",
    "likesMayNotStick": " Suka mungkin tidak bertahan.",
    "poolMeta": "Pool: {pool} · Pasangan: {matches} · Disukai: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Reset dek",
    "backOnboarding": "Kembali ke onboarding",
    "feedEyebrowDemo": "Pilihan mingguan · Demo",
    "feedEyebrowLive": "Pilihan mingguan · Pool ({source}, {count})",
    "feedTitle": "Bedakan dengan hati-hati",
    "left": "tersisa {count}",
    "pass": "Lewati",
    "interested": "Tertarik",
    "swipeHint": "Geser atau gunakan tombol. Pasangan terbuka hanya ketika minat saling dan tersimpan.",
    "celebrationEyebrow": "Minat saling",
    "celebrationTitle": "Anda cocok",
    "celebrationText": "{self} dan {other} sama-sama menunjukkan minat. Keselarasan nilai: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Chat terbuka untuk pasangan ini. Tetap hormat — perjanjian di atas kenyamanan.",
    "openChat": "Buka chat",
    "keepDiscerning": "Terus bedakan",
    "cardSeeking": "Mencari",
    "cardHobbies": "Hobi",
    "affinity": "Afinitas",
    "valuesScoreLabel": "Skor nilai",
    "scoreStrong": "Keselarasan kuat",
    "scoreSolid": "Keselarasan kokoh",
    "scoreModerate": "Keselarasan sedang",
    "scoreDifferent": "Ritme berbeda",
    "characterAxisFoot": "Sumbu karakter mencakup empat pilar",
    "youThem": "Anda {self} · Mereka {other}",
    "stampInterest": "Minat",
    "stampPass": "Lewati",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Skor nilai Anda saling dekat ({score} dari 100).",
    "explainLegacyFuller": "“Mengapa” yang lebih lengkap muncul setelah kalian berdua menyelesaikan pertanyaan pencocokan.",
    "explainFaith": "Intensitas iman Anda dekat — Anda mengikuti Yesus dengan keseriusan yang serupa.",
    "explainCharacter": "Cara Anda memperlakukan orang di rumah sejalan — damai, sopan, dan peduli.",
    "explainPurpose": "Anda menilai kejujuran diri serupa, yang merupakan tanda keseriusan bersama.",
    "explainHome": "Anda berbagi minat pada tanah, menanam makanan, atau rumah swasembada.",
    "explainAncestry": "Kalian berdua lebih suka latar belakang keluarga yang serupa. Itu preferensi, bukan filter — tidak ada yang disembunyikan karenanya.",
    "explainTemperament": "Minat dan temperamen Anda tumpang tindih.",
    "explainFallback": "Ada kemungkinan kecocokan pada jawaban yang kalian berdua isi.",
    "explainOverall": "Afinitas keseluruhan {score} dari 100.",
    "affinityAxes": {
      "faith": "Intensitas iman",
      "character": "Karakter & perilaku",
      "purpose": "Keselarasan tujuan hidup",
      "home": "Rumah & swasembada",
      "ancestry": "Afinitas budaya & latar belakang",
      "temperament": "Kecocokan temperamen"
    },
    "scaleAxes": {
      "loyalty": "Kesetiaan",
      "honesty": "Kejujuran",
      "passion": "Semangat",
      "commitment": "Komitmen"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat tidak tersedia",
    "unavailableText": "Pasangan ini hilang atau tidak termasuk dalam sesi Anda.",
    "backToMatches": "Kembali ke pasangan",
    "backMatches": "← Pasangan",
    "valuesSubscriber": "Nilai {score} · Pelanggan",
    "valuesTrial": "Nilai {score} · Uji coba",
    "valuesKept": "Nilai {score} · Pasangan dipertahankan",
    "empty": "Sapa dengan hati-hati. Di backend bersama, pesan tersinkron ke kedua ponsel setelah pasangan saling.",
    "placeholder": "Pesan {name}…",
    "ariaMessage": "Pesan",
    "send": "Kirim"
  },
  "billing": {
    "paywallCopy": "Setelah uji coba gratis, pertahankan semua orang yang sudah Anda cocokkan dan terus chat. Untuk melihat orang baru, berlangganan.",
    "signInToMatch": "Masuk untuk memakai pencocokan.",
    "signInFirst": "Masuk terlebih dahulu.",
    "subscriberUntil": "Pelanggan · sampai {date}",
    "renewal": "perpanjangan",
    "freeTrial": "Uji coba gratis · {days} hari (berakhir {date})",
    "soon": "segera",
    "trialEnded": "Uji coba berakhir · pasangan & chat tetap terbuka",
    "subscribe": "Berlangganan · ${price}/bln",
    "subscribeEarly": "Berlangganan lebih awal · ${price}/bln",
    "activeNote": "Langganan aktif — Anda dapat melihat orang baru lagi.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Simpan kode pemulihan Anda",
    "recoveryText": "Catat sekarang. Ditampilkan sekali. Jika Anda kehilangan frasa sandi, kode ini adalah satu-satunya cara mengatur ulang dalam uji tertutup.",
    "savedContinue": "Saya sudah menyimpannya — lanjutkan",
    "welcomeBack": "Selamat datang kembali",
    "createAccount": "Buat akun Anda",
    "intro": "Handle dan frasa sandi. Tidak ada email atau SMS yang dikirim. Id Anda tetap stabil di onboarding, tinjauan, dan pencocokan.",
    "tabLogin": "Masuk",
    "tabRegister": "Daftar",
    "handle": "Handle",
    "handlePlaceholder": "anda@contoh.com atau handle singkat",
    "passphrase": "Frasa sandi",
    "passphrasePlaceholder": "Minimal 8 karakter",
    "submitLogin": "Masuk",
    "submitRegister": "Buat akun",
    "backWelcome": "Kembali ke selamat datang"
  },
  "options": {
    "origin": {
      "african": "Afrika",
      "european": "Eropa",
      "asian": "Asia",
      "latino": "Latino / Hispanik",
      "middleEastern": "Timur Tengah",
      "indigenous": "Pribumi",
      "mixed": "Campuran",
      "other": "Lainnya",
      "dutch": "Belanda",
      "german": "Jerman",
      "any": "Terbuka — tanpa preferensi"
    },
    "interest": {
      "prayer": "Doa",
      "worship": "Ibadah",
      "reading": "Membaca",
      "hiking": "Hiking",
      "music": "Musik",
      "cooking": "Memasak",
      "farming": "Bertani / berkebun",
      "sports": "Olahraga",
      "missions": "Misi",
      "family": "Kehidupan keluarga",
      "crafts": "Kerajinan",
      "outdoors": "Luar ruangan"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ya",
      "no": "Tidak"
    },
    "id": {
      "titleEmpty": "ID pemerintah",
      "titleReady": "ID siap",
      "hintEmpty": "Paspor atau KTP nasional. Ambil foto langsung, atau pilih gambar/PDF. Keempat sudut terlihat.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · tersimpan",
      "previewAlt": "Pratinjau ID pemerintah",
      "pdfAria": "Dokumen PDF dipilih",
      "takePhoto": "Ambil foto",
      "retake": "Ambil ulang",
      "chooseFile": "Pilih berkas",
      "replaceFile": "Ganti berkas",
      "remove": "Hapus",
      "uploading": "Mengunggah…",
      "cameraTitle": "Foto ID Anda",
      "signIn": "Masuk sebelum mengunggah ID.",
      "uploadFailed": "Unggah gagal. Coba lagi.",
      "badFile": "Tidak dapat memakai berkas ini."
    },
    "video": {
      "titleEmpty": "Video konfirmasi",
      "titleLive": "Kamera langsung",
      "titleReady": "Video siap",
      "hintEmpty": "Sebutkan nama depan Anda dan bahwa Anda bergabung dengan UN8 dengan jujur. 5–15 detik.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Rekam",
      "cameraUpload": "Unggah kamera",
      "chooseFile": "Pilih berkas",
      "startRecording": "Mulai merekam",
      "cancel": "Batal",
      "stopSave": "Stop & simpan",
      "recordAgain": "Rekam lagi",
      "replaceFile": "Ganti berkas",
      "remove": "Hapus",
      "unsupported": "Rekaman langsung tidak tersedia di sini. Gunakan unggah kamera atau pilih berkas.",
      "permissionDenied": "Izin kamera ditolak. Anda masih bisa mengunggah berkas video singkat.",
      "signIn": "Masuk sebelum mengunggah video.",
      "uploadFailed": "Unggah gagal. Coba lagi.",
      "saveFailed": "Tidak dapat menyimpan rekaman.",
      "badVideo": "Tidak dapat memakai video ini."
    },
    "photos": {
      "count": "{count} / {max} foto",
      "minimumMet": "Minimum terpenuhi",
      "moreRequired": "{n} lagi diperlukan",
      "listAria": "Foto verifikasi",
      "photoAlt": "Foto {n}",
      "removeAria": "Hapus foto {n}",
      "camera": "Kamera",
      "takePhoto": "Ambil foto",
      "chooseFiles": "Pilih berkas",
      "uploading": "Mengunggah…",
      "hint": "Ambil foto membuka kamera langsung. Pilih berkas hanya untuk pilihan galeri. Foto wajah yang jelas — tanpa filter yang menyembunyikan identitas. Maks {max}.",
      "cameraTitle": "Ambil foto diri Anda",
      "signIn": "Masuk sebelum mengunggah foto.",
      "someFailed": "Beberapa foto gagal diunggah. Coba lagi yang gagal.",
      "addFailed": "Tidak dapat menambah foto."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Tutup",
      "capture": "Ambil",
      "cancel": "Batal",
      "hint": "Tahan stabil. Kamera langsung tetap terbuka sampai Anda mengambil.",
      "unavailable": "Kamera tidak tersedia di peramban ini. Gunakan Pilih berkas sebagai gantinya.",
      "permissionDenied": "Izin kamera ditolak atau tidak tersedia. Gunakan Pilih berkas sebagai gantinya.",
      "frameFailed": "Tidak dapat menangkap bingkai ini.",
      "saveFailed": "Tidak dapat menyimpan foto."
    },
    "uploadStatus": {
      "uploading": "mengunggah…",
      "failed": "unggah gagal",
      "savedLocally": "tersimpan lokal",
      "uploaded": "terunggah",
      "stored": "tersimpan",
      "awaitingUpload": "Menunggu unggahan",
      "localFallbackNote": "{error} Berkas tersimpan di perangkat ini; coba lagi saat endpoint sign aktif."
    }
  },
  "language": {
    "label": "Bahasa",
    "choose": "Pilih bahasa"
  },
  "shell": {
    "back": "Kembali",
    "goBackAria": "Kembali"
  }
} as Messages;
